import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface SubscriptionPlan {
  id: number;
  name: string;
  description: string;
  stripeProductId: string;
  stripePriceId: string;
  price: number;
  currency: string;
  billingInterval: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  private apiUrl = `${environment.apiUrl}/stripe`;

  constructor(private http: HttpClient) {}

  getPlans(): Observable<SubscriptionPlan[]> {
    return this.http.get<SubscriptionPlan[]>(`${this.apiUrl}/plans?_t=${new Date().getTime()}`);
  }

  getSubscriptionStatus(sessionId?: string): Observable<{status: string, hasAccessWithoutSubscription?: boolean}> {
    let url = `${this.apiUrl}/subscription-status?_t=${new Date().getTime()}`;
    if (sessionId) {
      url += `&sessionId=${sessionId}`;
    }
    return this.http.get<{status: string, hasAccessWithoutSubscription?: boolean}>(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
  }

  createCheckoutSession(priceId: string): Observable<{url: string}> {
    const successUrl = `${window.location.origin}/subscription?session_id={CHECKOUT_SESSION_ID}`;
    const cancelUrl = `${window.location.origin}/subscription`;
    return this.http.post<{url: string}>(`${this.apiUrl}/create-checkout-session`, {
      priceId,
      successUrl,
      cancelUrl
    });
  }

  createPortalSession(): Observable<{url: string}> {
    const returnUrl = `${window.location.origin}/subscription`;
    return this.http.post<{url: string}>(`${this.apiUrl}/create-portal-session`, {
      returnUrl
    });
  }
}
